import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import MgpStore from "./Store";


const initialState:any  = {
    PageState:""
}

const PageSetSlice = createSlice({
    name:"PageSet",
    initialState,
    reducers: {
        PageSetStateChng(state,action:PayloadAction<string>) {
            state.PageState = action.payload;
        }
    }
});
export type AppDispatch = typeof MgpStore.dispatch;
export const {PageSetStateChng} = PageSetSlice.actions;
export default PageSetSlice.reducer;
